import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<boolean | undefined> = (value) => ({
  borderRadius: (p) => p.spacing(1),
  width: value ? '100%' : (p) => p.spacing(58.75),
});

export const input: SxStyle = {
  flexDirection: 'row',
  alignItems: 'center',
  gap: 1,
  background: (p) => p.palette.common.white,
  borderRadius: (p) => p.spacing(0.75),
  cursor: 'pointer',
  padding: (p) => p.spacing(1, 1),
  height: (p) => p.spacing(5),
  border: (p) => `1px solid ${p.palette.grey[300]}`,
};

export const inputIcon: SxStyle = {
  color: (p) => p.palette.grey[500],
};

export const placeholder: SxStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const iconBox: SxStyle = {
  width: (p) => p.spacing(4),
  height: (p) => p.spacing(4),
  borderRadius: (p) => p.spacing(1),
  backgroundColor: (p) => p.palette.common.white,
  borderColor: (p) => p.palette.primary[100],
  borderWidth: '1px',
  borderStyle: 'solid',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const close: SxStyle = {
  cursor: 'pointer',
};
